// removed by extract-text-webpack-plugin
module.exports = {"App":"src-components-__App-module___App","searchResultBackdrop":"src-components-__App-module___searchResultBackdrop"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App.module.css
// module id = 1354
// module chunks = 0